import * as PickstarUserAnalytics from '@pickstar/user-analytics'

export default {
  computed: {
    analytics () {
      return PickstarUserAnalytics
    }
  },
  methods: {
    trackEvent (Event, params = []) {
      if (this.$analytics) {
        this.$analytics.track(new Event(...params))
      }
    }
  }
}
